import { Component, OnInit } from '@angular/core';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { AuthServiceProxy, UserModel } from '../../../../shared/service-proxies/event-service-proxy';
import { takeUntil } from 'rxjs';
import { ErrorService } from '../../../services/error/error.service';
import * as Sentry from '@sentry/angular';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    standalone: false,
    providers: [DestroyService]
})
export class HeaderComponent implements OnInit {
    user: UserModel = new UserModel();
    userFirstName: string = '';
    userLastName: string = '';

    constructor(private errorService: ErrorService, private _authService: AuthServiceProxy, private destroyService: DestroyService) { }
    
    ngOnInit(): void {
        this.getCurrentUser()
    }

    initial() {
        this.userFirstName = this.user.firstname ? this.user.firstname[0] : '';
        this.userLastName = this.user.lastname ? this.user.lastname[0] : '';
        console.log(this.userFirstName);
        Sentry.setUser({
    id: this.user.id,
    email: this.user.email,
    username: this.user.email
  });
    }

    getCurrentUser() {
        this._authService.me()
            .pipe(takeUntil(this.destroyService.onDestroy$))
            .subscribe(res => {
                this.user = res;
                this.initial()
            }, error => {
                this.errorService.handleError(error, 'Не удалось получить имя пользователя. Попробуйте позже.');
        })
    }
}
